const toSafeNumber = (value, fallback = 0) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
};

export const normalizeFrontendImportState = (bankStatus = {}) => {
  const canonical = bankStatus?.onboardingImportStatus || {};
  const phase = canonical.phase || bankStatus?.onboardingImportState || 'not_started';
  const connectedAccounts = Array.isArray(canonical.connectedAccounts)
    ? canonical.connectedAccounts
    : [];
  const connectedAccountsCount = toSafeNumber(
    canonical.connectedAccountsCount,
    toSafeNumber(bankStatus?.linkedAccountsCount, connectedAccounts.length)
  );
  const historicalImportComplete = canonical.historicalImportComplete === true;
  const aiPhase = canonical.aiPhase || (
    bankStatus?.initialImportBackgroundCategorizationRunning ? 'running' : 'idle'
  );
  const canReviewTransactions = canonical.reviewReady === true;
  const failed = canonical.failed === true || phase === 'failed';
  const failureReason = canonical.failureReason || bankStatus?.failureReason || null;

  return {
    phase,
    connectedAccounts,
    connectedAccountsCount,
    canEnterDashboard: canonical.canEnterDashboard === true,
    reportingDataReady: canonical.reportingDataReady === true,
    canUseBudgetAutobuild: canonical.canUseBudgetAutobuild === true,
    canReviewTransactions,
    historicalImportComplete,
    aiPhase,
    estimatedWaitLabel: canonical.estimatedWaitLabel || canonical.estimatedTimeLabel || bankStatus?.estimatedTimeLabel || null,
    lastUpdatedAt: canonical.lastUpdatedAt || bankStatus?.lastSyncAt || bankStatus?.onboardingImportStartedAt || null,
    error: failed ? {
      reason: failureReason || 'import_failed',
      retryAvailable: canonical.retryAvailable === true,
    } : null,
    retryAvailable: canonical.retryAvailable === true,
  };
};
